import type { DropzoneOptions } from "react-dropzone";
import type { Control, FieldPath, FieldValues } from "react-hook-form";

import { CloudUpload } from "lucide-react";

import {
	FileInput,
	FileUploader,
	FileUploaderContent,
	FileUploaderItem
} from "@/components/ui/file-upload";
import {
	FormControl,
	FormField,
	FormItem,
	FormMessage
} from "@/components/ui/form";
import { cn } from "@/lib/utils";

interface UploadFileProps<T extends FieldValues> {
	files: File[] | null;
	setFiles: (files: File[] | null) => void;
	accept?: string;
	className?: string;
	name: FieldPath<T>;
	control: Control<T>;
	dropZoneConfig?: DropzoneOptions;
}
export default function UploadFile<T extends FieldValues>({ files, setFiles, className, name, control, dropZoneConfig }: UploadFileProps<T>) {
	dropZoneConfig ??= {
		maxFiles: 15,
		maxSize: 1024 * 1024 * 4,
		multiple: true

	};

	return (

		<FormField
			control={control}
			name={name}
			render={({ field }) => (
				<FormItem>
					<FormControl>
						<FileUploader
							{...field}
							value={files}
							onValueChange={setFiles}
							dropzoneOptions={dropZoneConfig}
							className={cn("relative bg-background rounded-lg p-1")}
						>
							<FileUploaderContent className="flex flex-row flex-wrap gap-2">
								{files
								&& files.length > 0
								&& files.map((file, i) => (
									<FileUploaderItem key={crypto.randomUUID()} index={i} className="group relative size-32 rounded-lg border border-primary overflow-hidden">
										<img src={URL.createObjectURL(file)} alt={file.name} className="w-full h-full object-cover" />
									</FileUploaderItem>
								))}
							</FileUploaderContent>
							<FileInput
								id="fileInput"

								accept="image/png,image/jpg,image/jpeg"

								className={cn("outline-dashed outline-1 outline-slate-500", className)}
							>
								<div className="flex items-center justify-center flex-col p-8 w-full ">
									<CloudUpload className="text-gray-500 w-10 h-10" />
									<p className="mb-1 text-sm text-gray-500 dark:text-gray-400">
										<span className="font-semibold">Click to upload</span>
											&nbsp; or drag and drop
									</p>
									<p className="text-xs text-gray-500 dark:text-gray-400">
										PNG, JPG
									</p>
								</div>
							</FileInput>
						</FileUploader>
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	);
}
